import PropTypes from 'prop-types';
import React from 'react';
import LeftTopModal from './leftTopModal';
import OpenActivity from './openActivity';

const LeftSection = ({
  leads,
  accounts,
  objects,
  activities,
  setRouteInfo,
  tagView,
  todayNewTotal,
  setTagValue,
  taskStatus,
}) => (
  <div>
    <LeftTopModal
      leads={leads}
      accounts={accounts}
      objects={objects}
      setRouteInfo={setRouteInfo}
      tagView={tagView}
      todayNewTotal={todayNewTotal}
      setTagValue={setTagValue}
    />
    <OpenActivity
      taskStatus={taskStatus}
      setRouteInfo={setRouteInfo}
      activities={activities}
    />
  </div>
);

LeftSection.propTypes = {
  leads: PropTypes.array.isRequired,
  accounts: PropTypes.array.isRequired,
  objects: PropTypes.array.isRequired,
  activities: PropTypes.array.isRequired,
  taskStatus: PropTypes.array.isRequired,
};
export default LeftSection;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/leftSection.js